import React, { useEffect, useState, useCallback } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { useNavigate } from "react-router-dom";

import ConfirmBuyModal from "../components/ConfirmBuyModal";

import { ITreasureContract,NFTContarct, USDTContarct,NFTDataContract,DepositContract } from "../config/contractConfig";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTDataContractABI from "../abis/NFTDataContractABI.json";
import DepositAbi from "../abis/DepositAbi.json";

import Loader from "../components/Loader";
import BNB from "../assets/bnb.svg";
import nftimage from "../assets/img/package-nft.jpg";
import { FaCopy, FaCheck, FaCartArrowDown } from "react-icons/fa";

const NFTMarketPlace = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const navigate = useNavigate();
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [allNFTs, setAllNFTs] = useState([]);
  const [visibleNFTs, setVisibleNFTs] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [loadingSkeleton] = useState(Array(12).fill(0));
  const [activeTab, setActiveTab] = useState("All NFTs");
  const [pageSize, setPageSize] = useState(40);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusText, setStatusText] = useState({ visible: false });
  const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [allTokenIds, setAllTokenIds] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [tradeFundAmount, setTradeFundAmount] = useState("0");
    const toWeiSafe = (val) => {
      if (!val || Number(val) <= 0) return "0";
      return Web3.utils.toWei(val.toString(), "ether"); // 18 decimals
    };
    const [USDTBalance, setUSDTBalance] = useState(null);
  
const [priceBreakdown, setPriceBreakdown] = useState({
  base: 0,
  extra: 0,
  total: 0,
  isResale: false,
});
 const [ownerFilter, setOwnerFilter] = useState("");
 const [walletTokenIds, setWalletTokenIds] = useState([]);
 const [toPrice, setToPrice] = useState("");
    const [fromPrice, setFromPrice] = useState("");

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

    const formatBalance2 = (balance) =>
    balance ? parseFloat(balance).toFixed(6) : "0.00";
  // 🔹 CURRENT TIME (seconds)
  const getNow = () => Math.floor(Date.now() / 1000);
  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "TradeHistory") navigate("/my-nft-history");
    else if (tab === "NFT Activity") navigate("/nft-trade-history");
    else if (tab === "Standard NFTs") navigate("/nft-24h-list");
  };

  // INIT WEB3
  useEffect(() => {
    if (client?.transport) setWeb3(new Web3(client.transport));
    else if (window.ethereum) setWeb3(new Web3(window.ethereum));
  }, [client]);

  const getSeed = () => {
  return address
    ? address.toLowerCase()
    : navigator.userAgent;
};

const shuffleLight = (arr, seed) => {
  const a = [...arr];
  let h = 0;

  for (let i = 0; i < seed.length; i++) {
    h = (h << 5) - h + seed.charCodeAt(i);
    h |= 0;
  }

  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.abs((h + i) % (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

    useEffect(() => {
      if (isConnected && address && web3) {
        fetchData();
      }
    }, [address, isConnected, web3]);

  const fetchData = async () => {
      try {
  
        const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
        const _USDTBalance = await USDTInstance.methods.balanceOf(address).call();
        setUSDTBalance(web3.utils.fromWei(_USDTBalance, "ether"));

      } 
      catch (error) {
        console.error("Error Fetching Data:", error);
      }
    };

const loadTradingFund = useCallback(async () => {
  if (!web3 || !address) return;

  try {
    const NFTInstance = new web3.eth.Contract(DepositAbi, DepositContract);

    const data = await NFTInstance.methods
      .getTradingIncomeCapping(address)
      .call();

    setTradeFundAmount(
      web3.utils.fromWei(data.tradeFundAmount, "ether")
    );

  } catch (err) {
    console.error("Trading Fund Error:", err);
  }
}, [web3, address]);

useEffect(() => {
  if (web3 && address) {
    loadTradingFund();
  }
}, [web3, address, loadTradingFund]);

  // ================= STEP 1: LOAD ALL TOKEN IDS =================
  const loadAllTokenIds = useCallback(async () => {
    if (!web3) return;

    setLoading(true);
    try {
      const NFT = new web3.eth.Contract(NFTDataContractABI, NFTDataContract);

      const tokenIds = await NFT.methods
        .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, false)
        .call();

      console.log("TOTAL NFT IDS:", tokenIds.length);
    const shuffled = shuffleLight(tokenIds, getSeed());
    setAllTokenIds(shuffled);
      // setAllTokenIds(tokenIds);
    // 🔥 important fix
    if (tokenIds.length === 0) {
      setVisibleNFTs([]);
      setLoading(false);
    }
    } catch (err) {
      console.error("LOAD TOKEN IDS ERROR:", err);
    }
  }, [web3]);

  // const loadAllTokenIds = useCallback(async () => {
  //   if (!web3) return;

  //   setLoading(true);
  //   try {
  //     const NFT = new web3.eth.Contract(NFTDataContractABI, NFTDataContract);

  //     const tokenIds = await NFT.methods
  //       .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, false)
  //       .call();

  //     console.log("TOTAL NFT IDS:", tokenIds.length);

  //     setAllTokenIds(tokenIds);
  //   } catch (err) {
  //     console.error("LOAD TOKEN IDS ERROR:", err);
  //   }
  // }, [web3]);
  
  const loadWalletTokenIds = useCallback(
    async (walletAddr) => {
      if (!web3 || !walletAddr) return;

      setLoading(true);
      try {
        // const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
       const NFT = new web3.eth.Contract(NFTDataContractABI, NFTDataContract);
        const ids = await NFT.methods
          .getAllActiveListedNFTs("0", "0", walletAddr, true)
          .call();

        setWalletTokenIds(ids);
        setCurrentPage(1);
        setVisibleNFTs([]);
      } catch (err) {
        console.error("LOAD WALLET NFT ERROR:", err);
      }
      setLoading(false);
    },
    [web3]
  );

  useEffect(() => {
  if (web3 && initialLoad) {
    loadAllTokenIds();
    setInitialLoad(false);
  }
}, [web3, initialLoad]);

useEffect(() => {
  if (visibleNFTs.length === 0) return;

  const interval = setInterval(() => {
    setVisibleNFTs((prev) =>
      shuffleLight(
        prev,
        (address || "guest") + Math.floor(Date.now() / 20000)
      )
    );
  }, 20000);

  return () => clearInterval(interval);
}, [visibleNFTs.length, address]);


useEffect(() => {
  if (!web3 || visibleNFTs.length === 0) return;

  const interval = setInterval(async () => {
    try {
      // const NFT = new web3.eth.Contract(NFTABI, NFTDataContract);
 const NFT = new web3.eth.Contract(NFTDataContractABI, NFTContarct);
      // 🔹 fresh active ids
      const activeIds = await NFT.methods
        .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, false)
        .call();

      const activeSet = new Set(activeIds.map(String));

      // 🔹 remove sold NFTs only
      setVisibleNFTs((prev) => {
        const filtered = prev.filter((nft) =>
          activeSet.has(nft.tokenId.toString())
        );

        // 🔹 same random feel as before
        return shuffleLight(
          filtered,
          (address || "guest") + Math.floor(Date.now() / 20000)
        );
      });
    } catch (e) {
      console.error("auto silent refresh error", e);
    }
  }, 25000);

  return () => clearInterval(interval);
}, [web3, visibleNFTs.length, address]);



  // ================= STEP 1: LOAD ONLY TOKEN IDS =================
  const loadTokenIds = useCallback(async () => {
    if (!web3) return;

    setLoading(true);
    try {
      // const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
     const NFT = new web3.eth.Contract(NFTDataContractABI, NFTContarct);
      const ids = await NFT.methods
        .getAllActiveListedNFTs("0", "0", ZERO_ADDRESS, true)
        .call();

      console.log("TOTAL TOKEN IDS:", ids.length);
      setAllTokenIds(ids);
    } catch (err) {
      console.error("LOAD TOKEN IDS ERROR:", err);
    }
    // setLoading(false);
  }, [web3]);

  // useEffect(() => {
  //   if (web3) loadTokenIds();
  // }, [web3, loadTokenIds]);

  
  // ================= STEP 2: LOAD NFT DETAILS BY IDS =================
  const loadNFTDetailsByIds = useCallback(
    async (ids) => {
      if (!web3 || ids.length === 0) return;

      try {
        const NFT = new web3.eth.Contract(NFTABI, NFTContarct);
        const NFTData = new web3.eth.Contract(
          NFTDataContractABI,
          NFTDataContract
        );

        const list = await Promise.all(
          ids.map(async (id) => {
            try {
              const info = await NFT.methods.nftInfo(id).call();
              const details = await NFTData.methods.getNFTDetails(id).call();

              // ❌ OWN NFT REMOVE
              if (
                details.ownerAddr?.toLowerCase() === address?.toLowerCase()
              )
                return null;

              return {
                tokenId: id.toString(),
                price: Number(
                  web3.utils.fromWei(info.priceUSDT, "ether")
                ),
                owner: details.ownerAddr,
                image: info.imageURI,
              };
            } catch {
              return null;
            }
          })
        );

        setVisibleNFTs(list.filter(Boolean));
      } catch (err) {
        console.error("LOAD NFT DETAILS ERROR:", err);
      }
      setLoading(false);
    },
    [web3, address]
  );
  const loadPriceFilteredTokenIds = useCallback(
    async (from, to) => {
      if (!web3) return;

      setLoading(true);
      try {
        const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

        const fromWei = toWeiSafe(from);
        const toWei = to ? toWeiSafe(to) : "0";

        const ids = await NFT.methods
          .getAllActiveListedNFTs(
            fromWei,
            toWei,
            ZERO_ADDRESS,
            true
          )
          .call();

        // 🔥 RESET STATES (IMPORTANT)
        setOwnerFilter("");
        setSearch("");
        setIsSearchMode(false);
        setWalletTokenIds([]);
        setAllTokenIds(ids);
        setCurrentPage(1);
        setVisibleNFTs([]);

      } catch (err) {
        console.error("PRICE FILTER ERROR:", err);
      }
      setLoading(false);
    },
    [web3]
  );
  // ================= STEP 3: PAGINATION BASED FETCH =================
  useEffect(() => {
    if (allTokenIds.length === 0) return;

    const start = (currentPage - 1) * pageSize;
    const end = currentPage * pageSize;

    const pageIds = allTokenIds.slice(start, end);

    loadNFTDetailsByIds(pageIds);
  }, [allTokenIds, currentPage, pageSize, loadNFTDetailsByIds]);

  // ================= PAGINATION =================
  const totalRecords = allTokenIds.length;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

    const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };
  // ============================================================
  // BUY NOW → OPEN MODAL
  // ============================================================
  //   const handleBuyNow = (nft) => {
  //   setSelectedNFT(nft);
  //   setShowModal(true);
  //   setStatusText({
  //     visible: false,
  //     type: "",
  //     title: "",
  //     message: "",
  //     persist: false,
  //   });
  // };

//   const handleBuyNow = async (nft) => {
//   setSelectedNFT(nft);

//   try {
//     const NFTData = new web3.eth.Contract(
//       NFTDataContractABI,
//       NFTDataContract
//     );

//     const details = await NFTData.methods
//       .getNFTDetails(nft.tokenId)
//       .call();

//     const owner = details.ownerAddr;

//     const isResale =
//       owner &&
//       owner.toLowerCase() !== NFTContarct.toLowerCase();

//     const base = Number(nft.price);
//     let extra = 0;

//     if (isResale) {
//       extra = (base * 10) / 100;
//     }

//     const total = base + extra;

//     // 🔥 YAHI MAIN CHEEZ
//     setPriceBreakdown({
//       base,
//       extra,
//       total,
//       isResale,
//     });

//     setShowModal(true); // ✅ sirf yahi open karega modal

//     setStatusText({
//       visible: false,
//       type: "",
//       title: "",
//       message: "",
//       persist: false,
//     });

//   } catch (err) {
//     console.error(err);
//   }
// };

const handleBuyNow = async (nft) => {
  setSelectedNFT(nft);

  try {
    const base = Number(nft.price);

    const extra = (base * 10) / 100; // 🔥 sab pe lagega
    const total = base + extra;

    setPriceBreakdown({
      base,
      extra,
      total,
      isResale: true, // optional
    });

    setShowModal(true);

    setStatusText({
      visible: false,
      type: "",
      title: "",
      message: "",
      persist: false,
    });

  } catch (err) {
    console.error(err);
  }
};

  const handlePriceSearch = () => {
    const from = Number(fromPrice || 0);
    const to = Number(toPrice || 0);

    // ❌ dono empty
    if (!from && !to) {
      alert("Enter From or To price");
      return;
    }

    // ❌ dono 10 se kam
    if (from < 10 && to < 10) {
      alert("Minimum price filter is 10 USDT");
      return;
    }

    // ✅ OK → blockchain call
    loadPriceFilteredTokenIds(fromPrice, toPrice);
  };

const PreAuthorizeNFT = async () => {
  try {
    // ⭐ STEP 1: USER REGISTERED CHECK
    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    const user = await Contract.methods.objUser(address).call();

    if (!user?.userId || user.userId === "0") {
      setStatusText({
        visible: true,
        type: "error",
        title: "Not Registered",
        message:
          "Your account is not activated yet Please purchase to complete your registration.",
        persist: true,
      });
      return;
    }

    const ContractNFT = new web3.eth.Contract(
      NFTABI,
      NFTContarct
    );

    // ================================
    // 🔥 OWNER CHECK (NEW)
    // ================================
    const NFTData = new web3.eth.Contract(
      NFTDataContractABI,
      NFTDataContract
    );

    // const details = await NFTData.methods
    //   .getNFTDetails(selectedNFT.tokenId)
    //   .call();

    // const owner = details.ownerAddr;

    // const isResale =
    //   owner &&
    //   owner.toLowerCase() !== NFTContarct.toLowerCase();

    // ================================
    // 🔥 PRICE
    // ================================
    const priceWei = window.BigInt(
      web3.utils.toWei(selectedNFT.price.toString(), "ether")
    );

    const extraAmount = (priceWei * 10n) / 100n; // 🔥 sab pe 10%
    const finalAmount = priceWei + extraAmount;

    // ================================
    // 🔥 USER CAPPING
    // ================================
    const userCapping = await ContractNFT.methods
      .getUserCappingStatus(address)
      .call();

    const availableCapping = window.BigInt(
      userCapping.availableCapping
    );

    // ================================
    // 🔥 TRADING FUND
    // ================================
    const NFTInstance = new web3.eth.Contract(
      DepositAbi,
      DepositContract
    );

    const cappingDetails = await NFTInstance.methods
      .getTradingIncomeCapping(address)
      .call();

    const depositAvailableCapping = window.BigInt(
  cappingDetails.availableCapping
);

// 🔴 NEW CHECK (IMPORTANT)
if (depositAvailableCapping === 0n) {
  setStatusText({
    visible: true,
    type: "error",
    title: "No Capping Available",
    message:
      "You have no available 2.5x deposit capping left. You cannot purchase this NFT.",
    persist: true,
  });
  return false;
}

    const tradeFundAmount = window.BigInt(
      cappingDetails.tradeFundAmount
    );

    // 🔴 STEP 1: TRADING FUND CHECK (ONLY PRICE)
    if (priceWei > tradeFundAmount) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Insufficient Trading Fund",
        message:
          "Your trading fund balance is not enough to purchase this NFT.",
        persist: true,
      });
      return false;
    }

    // 🔴 STEP 2: CAPPING CHECK (ONLY PRICE)
    if (priceWei > availableCapping) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Capping Limit Exceeded",
        message:
          "You cannot purchase this NFT because it exceeds your available capping limit.",
        persist: true,
      });
      return false;
    }

    // ================================
    // 🔥 ONLY RESALE CASE HANDLE
    // ================================
      const USDT = new web3.eth.Contract(
        USDTABI,
        USDTContarct
      );

      // 🔴 WALLET CHECK (ONLY EXTRA)
      const balance = await USDT.methods
        .balanceOf(address)
        .call();

      if (window.BigInt(balance) < extraAmount) {
        setStatusText({
          visible: true,
          type: "error",
          title: "Insufficient Wallet Balance",
          message:
            "Not enough USDT in wallet for 10% resale fee.",
          persist: true,
        });
        return false;
      }

      // 🔴 APPROVAL (FULL AMOUNT)
      const allowance = await USDT.methods
        .allowance(address, NFTContarct)
        .call();

      if (window.BigInt(allowance) < extraAmount) {
        setStatusText({
          visible: true,
          type: "loading",
          title: "Approving USDT",
          message: "Please approve total amount...",
        });

        await USDT.methods
          .approve(NFTContarct, extraAmount.toString())
          .send({ from: address });
      }

    // ================================
    // ✅ DONE
    // ================================
    return true;
  } catch (err) {
    setStatusText({
      visible: true,
      type: "error",
      title: "Approval Failed",
      message: err.message,
      persist: true,
      onClose: () => {
        setStatusText({ visible: false });
        setShowModal(false);
      },
    });

    return false;
  }
};

//   const PreAuthorizeNFT = async () => {
//     try {

//         // ⭐ STEP 1: USER REGISTERED CHECK
//           const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
//           const user = await Contract.methods.objUser(address).call();
//           if (!user?.userId || user.userId === "0") {
//             setStatusText({
//               visible: true,
//               type: "error",
//               title: "Not Registered",
//               message: "Your account is not activated yet Please purchase to complete your registration.",
//               persist: true,
//               setStatusText,
//             });
//             return; // ❌ STOP HERE (MetaMask will NOT open)
//           }

//           const ContractNFT = new web3.eth.Contract(NFTABI, NFTContarct);
          
//           const userCapping = await ContractNFT.methods.getUserCappingStatus(address).call();

//           const availableCapping = window.BigInt(userCapping.availableCapping);
      
//         const priceWei = window.BigInt(
//   web3.utils.toWei(selectedNFT.price.toString(), "ether")
// );

//  const NFTInstance = new web3.eth.Contract(DepositAbi, DepositContract);

//     // 🔹 GET TRADING CAPPING DATA
//     const cappingDetails = await NFTInstance.methods
//       .getTradingIncomeCapping(address)
//       .call();

//     const tradeFundAmount = window.BigInt(cappingDetails.tradeFundAmount);


//     // 🔴 STEP 1: TRADE FUND CHECK
//     if (priceWei > tradeFundAmount) {
//       setStatusText({
//         visible: true,
//         type: "error",
//         title: "Insufficient Trading Fund",
//         message:
//           "Your trading fund balance is not enough to purchase this NFT. Please deposit trading funds.",
//         persist: true,
//       });
//       return false;
//     }


// // 2️⃣ +2 token → wei → BigInt
// // const twoWei = window.BigInt(
// //   web3.utils.toWei("2", "ether")
// // );
//         // const approveAmount = priceWei +twoWei;

//         // //  STEP 3: CAPPING CHECK (IMPORTANT)
//         if (priceWei > availableCapping) {
//           setStatusText({
//             visible: true,
//             type: "error",
//             title: "Capping Limit Exceeded",
//             message:
//               "You cannot purchase this NFT because it exceeds your available capping limit.",
//             persist: true,
//           });
//           return false; //  STOP (MetaMask will NOT open)
//         }
//       // const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

//       // setStatusText({
//       //   visible: true,
//       //   type: "loading",
//       //   title: "Approving USDT",
//       //   message: "Please wait…",
//       // });

//       // const allowance = await USDT.methods
//       //   .allowance(address, NFTContarct)
//       //   .call();

//       // if (window.BigInt(allowance) >= window.BigInt(approveAmount)) return true;

//       // await USDT.methods
//       //   .approve(NFTContarct, approveAmount)
//       //   .send({ from: address });

//       return true;
//     } catch (err) {
//       setStatusText({
//         visible: true,
//         type: "error",
//         title: "Approval Failed",
//         message: err.message,
//         persist: true,
//         // ensure modal can close by clicking OK or X — modal will call status.onClose if provided
//         onClose: () => {
//           setStatusText({ visible: false });
//           setShowModal(false);
//         },
//       });
//       return false;
//     }
//   };

   const BuyNFT = async () => {
    try {
      const NFT = new web3.eth.Contract(NFTABI, NFTContarct);

      setStatusText({
        visible: true,
        type: "loading",
        title: "Buying NFT",
        message: "Please wait…",
        persist: false,
      });

      await NFT.methods.buyNFT(selectedNFT.tokenId).send({ from: address });

        // Remove the purchased NFT from the list immediately
        setAllNFTs((prev) =>
          prev.filter((nft) => nft.tokenId !== selectedNFT.tokenId)
        );
        setVisibleNFTs((prev) =>
          prev.filter((nft) => nft.tokenId !== selectedNFT.tokenId)
        );

      setStatusText({
        visible: true,
        type: "success",
        title: "Success",
        message: `NFT Purchased Successfully`,
        persist: true, // show OK button
        // when user clicks OK (or we can call onClose), hide modal and reload data
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
          // reload NFT list (no full page refresh)
        },
      });

      // we already call loadAllNFTData() inside onClose so no immediate call here
      return true;
    } catch (err) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Purchase Failed",
        message: err.message,
        persist: true,
        onClose: () => {
          setStatusText({ visible: false });
          setShowModal(false);
        },
      });
      return false;
    }
  };



  // ============================================================
  // FINAL CONFIRM BUTTON INSIDE MODAL
  // ============================================================
    const handleConfirm = async () => {
    const approved = await PreAuthorizeNFT();
    if (!approved) return;
  
    await BuyNFT();
  };

  const [copiedIndex, setCopiedIndex] = useState(null);
  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1200);
  };

  const maskAddress = (addr) =>
    addr ? addr.slice(0, 4) + "***" + addr.slice(-4) : "";

  if (loading) return <Loader />;

  return (
    <div className="page">
      <h4 className="mb-3">
        <span className="text-warning">NFT</span>{" "}
        <span className="fw-lighter">Marketplace</span>
      </h4>

{/* trading Balance section start */}
<>
<style>
{`
.trading-fund-box{
  display:flex;
  justify-content:space-between;
  align-items:center;
  background:linear-gradient(135deg,#1c1c1c,#111);
  border:1px solid rgba(240,185,11,0.35);
  border-radius:12px;
  padding:14px 18px;
  margin-bottom:18px;
  box-shadow:0 0 12px rgba(240,185,11,0.25);
}

.fund-left{
  display:flex;
  align-items:center;
  gap:8px;
}

.fund-icon{
  font-size:18px;
  color:#f0b90b;
}

.fund-left span{
  font-size:14px;
  color:#bbb;
}

.fund-right{
  font-size:18px;
  color:#f0b90b;
  font-weight:700;
}

/* Mobile Responsive */
@media(max-width:768px){

.trading-fund-box{
  padding:12px 14px;
}

.fund-left span{
  font-size:13px;
}

.fund-right{
  font-size:16px;
}

}
`}
</style>

<div className="trading-fund-box">
  <div className="fund-left">
    <span className="fund-icon">💰</span>
    <span>Trading Balance</span>
  </div>

  <div className="fund-right">
    {formatBalance2(tradeFundAmount)} USDT
  </div>
</div>

<div className="trading-fund-box">
  <div className="fund-left">
    <span className="fund-icon">💰</span>
    <span>Available Wallet USDT</span>
  </div>

  <div className="fund-right">
    {formatBalance2(USDTBalance)} USDT
  </div>
</div>
</>
{/* trading Balance section End */}



       {/* Top Tabs */}
     <div className="row  ">
          <div className="d-flex justify-content-between align-items center">
            <div className="filter-left">
            {["All NFTs", "NFT Activity", "TradeHistory","Standard NFTs"].map((tab) => (
              <a
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </a>
            ))}
          </div>
            {/* <button
              type="button"
              className=" "
              id="filterBtn"
              onClick={() => setIsFilterOpen(true)}
            >
              Filter <i className="fa-solid fa-filter ms-1"></i>
            </button> */}
          </div>

          <div className="col-md-12 mb-3">
            <div className="">



              {/* <input
  type="number"
  placeholder="From Price"
  value={fromPrice}
  onChange={(e) => {
    const v = e.target.value;
    setFromPrice(v);

    if (v || toPrice) {
      loadPriceFilteredTokenIds(v, toPrice);
    }
  }}
  style={{ width: 110, marginLeft: 8 }}
/>

<input
  type="number"
  placeholder="To Price"
  value={toPrice}
  onChange={(e) => {
    const v = e.target.value;
    setToPrice(v);

    if (fromPrice || v) {
      loadPriceFilteredTokenIds(fromPrice, v);
    }
  }}
  style={{ width: 110, marginLeft: 6 }}
/> */}

              {/* <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="desc">DESC</option>
              <option value="asc">ASC</option>
            </select> */}


            </div>
          </div>
        </div>

      {/* NFT GRID */}
      <div className="row">
        {visibleNFTs.map((nft, i) => (
          <div className="col-md-4 col-lg-3 mb-4" key={i}>
            <div className="nft">
              <div className="main">
                <img
                  className="tokenImage"
                 src={`${nft.image}?v=${nft.tokenId}-${Date.now()}`}
                  alt="NFT"
                  style={{ borderRadius: 10 }}
                />

                {/* <h2>NFT #{nft.tokenId}</h2> */}


                <div className="tokenInfo">
                  <div className="price">
                    <ins>◘</ins>
                    <p>{formatBalance(nft.price)} USDT</p>
                  </div>
                  <div className="duration">
                    <ins>◷</ins>
                    <p>ON SALE</p>
                  </div>
                </div>

                <hr />

                {/* <div className="creator">
                  <div className="wrapper">
                    <img
                      src={BNB}
                      alt="BNB"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                  </div>

                  <p>
                    <ins>Owner</ins> {maskAddress(nft.owner)}
                  </p>

                  <div className="ref-copy-box">
                    <button
                      className="copy-btn"
                      onClick={() => handleCopy(nft.owner, i)}
                    >
                      {copiedIndex === i ? (
                        <FaCheck className="copy-icon copied" />
                      ) : (
                        <FaCopy className="copy-icon" />
                      )}
                    </button>
                  </div>
                </div> */}

                <button
                  className="new_joining_btn"
                  onClick={() => handleBuyNow(nft)}
                >
                  <FaCartArrowDown className="me-2" />
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Skeleton Loading */}
        {/* {loadingSkeleton.map((_, i) => (
          <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
            <div className="skeleton-card">
              <div className="skeleton-box"></div>
              <div className="NFT-card-body">
                <div className="skeleton-line w-50"></div>
                <div className="skeleton-line w-30"></div>
              </div>
            </div>
          </div>
        ))}
      </div> */}

        {/* ✅ SKELETON → ONLY WHEN NFT = 0 */}
        {loading && visibleNFTs.length === 0 &&
          Array.from({ length: pageSize }).map((_, i) => (
            <div className="col-md-4 col-lg-3 mb-4" key={"s" + i}>
              <div className="skeleton-card">
                <div className="skeleton-box"></div>
                <div className="NFT-card-body">
                  <div className="skeleton-line w-50"></div>
                  <div className="skeleton-line w-30"></div>
                </div>
              </div>
            </div>
          ))}

                {visibleNFTs.length === 0 &&
            Array.from({ length: pageSize }).map((_, i) => (
              <div className="col-6 col-md-4 col-lg-3 mb-4" key={"s" + i}>
                <div className="skeleton-card">
                  <div className="skeleton-box"></div>
                  <div className="NFT-card-body">
                    <div className="skeleton-line w-50"></div>
                    <div className="skeleton-line w-30"></div>
                  </div>
                </div>
              </div>
            ))}
        </div>

      {/* Total Counter */}
         <div className="d-flex justify-content-between align-items center"> 
        
        {!isSearchMode && (
          <div className="mini-pagination">

            {/* First */}
            {/* <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(1)}
            >
              First
            </button> */}

            {/* Previous Arrow */}
            {/* <button
              disabled={currentPage === 1}
              onClick={prevPage}
            >
              «
            </button> */}

            {/* Sliding Page Numbers (5 visible) */}
            {/* {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page >= currentPage - 2 &&
                  page <= currentPage + 2
              )
              .map((page) => (
                <button
                  key={page}
                  className={currentPage === page ? "active-mini" : ""}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))} */}

            {/* Next Arrow */}
            {/* <button
              disabled={currentPage === totalPages}
              onClick={nextPage}
            >
              »
            </button> */}

            {/* Last */}
            {/* <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
            >
              Last
            </button> */}

          </div>
        )}
        {/* <p className="mb-2 text-end  d-flex align -items center justify-content-bitween">
          <span>
            Total NFTs: <b>{totalRecords}</b>
          </span>
          <span>| Page: {currentPage}/{totalPages}</span>
        </p> */}
      </div>
      {/* Pagination */}
      {/* <div className="pagination-box">
        <button disabled={currentPage === 1} onClick={prevPage}>
          Previous
        </button>
        <button disabled={currentPage === totalPages} onClick={nextPage}>
          Next
        </button>
      </div> */}



{/* Overlay */}
      <div
        className={`fillter-layout ${isFilterOpen ? "show" : ""}`}
        onClick={() => setIsFilterOpen(false)}
      ></div>

      {/* Filter Sidebar */}
      <div className={`comSearchItem ${isFilterOpen ? "show" : ""}`}>

        <label className="form-label">Token ID</label>
        <div className="input-icon">
          <input
            type="text"
            className="form-control"
            placeholder="Search by Token ID..."
            value={search}
            onChange={(e) => {
              const val = e.target.value.trim();
              setSearch(val);
              if (val) {
                setIsSearchMode(true);
              } else {
                setIsSearchMode(false);
                setCurrentPage(1);
              }
            }}
          />
        </div>

        {/* WALLET SEARCH */}
        <label className="form-label">Wallet</label>
        <div className="input-icon">
          <input
            placeholder="Search Wallet (0x...)"
            className="form-control"
            value={ownerFilter}
            onChange={(e) => {
              const v = e.target.value.trim();
              setOwnerFilter(v);

              if (v && v.startsWith("0x") && v.length === 42) {
                setSearch("");
                setIsSearchMode(false);
                setCurrentPage(1);
                loadWalletTokenIds(v);
              }

              if (!v) {
                setWalletTokenIds([]);
                setCurrentPage(1);
                loadTokenIds();
              }
            }}
          />
        </div>

        {/* From Price */}
        <label className="form-label">From Price</label>
        <input
          type="number"
          placeholder="From Price"
          className="form-control"
          value={fromPrice}
          onChange={(e) => {
            const v = e.target.value;
            setFromPrice(v);
            if (!v && !toPrice) {
              loadTokenIds();
            }
          }}
        />

        {/* To Price */}
        <label className="form-label">To Price</label>
        <input
          type="number"
          placeholder="To Price"
          className="form-control"
          value={toPrice}
          onChange={(e) => {
            const v = e.target.value;
            setToPrice(v);
            if (!v && !fromPrice) {
              loadTokenIds();
            }
          }}
        />

        {/* Buttons */}
        <div className="d-flex gap-2 align-items-center mt-3">
          <button className="btn btn-success" onClick={handlePriceSearch}>
            Search
          </button>

          <button
            className="btn btn-danger"
            onClick={() => {
              setFromPrice("");
              setToPrice("");
              loadTokenIds();
            }}
          >
            Reset
          </button>
        </div>

        {/* Close Button */}
        <a
          href="javascript:void(0)"
          className="close-filter"
          onClick={() => setIsFilterOpen(false)}
        >
          <i className="fa fa-times"></i>
        </a>

      </div>
      {/* MODAL HERE */}
      <ConfirmBuyModal
        open={showModal}
        pkg={selectedNFT}
         purchaseType="nft"
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        status={statusText}
         setStatusText={setStatusText} 
          priceBreakdown={priceBreakdown}  // 🔥 ADD THIS
      />
    </div>
  );
};

export default NFTMarketPlace;
